module.exports = __webpack_public_path__ + "media/icons/comments-3b3f6789.svg";